$.account = {
	callback: {
		create: {
			success: function(data) {
				location.href = $.config.host + '?secretKey='+ data.secretKey;
			}
		}
	},
	
	push: {
		create: function() {
			$('#dialogToolbar').ajax_callback('/json/account/create', {
				'name' : $('#accountName').val(),
				'phone' : $('#accountPhone').val(),
				'email' : $('#accountEmail').val(),
				'password' : $('#accountPassword').val()
			}, {
				alertToolbar: true,
				callback_success: $.account.callback.create.success
			});
		}
	}
};